<ion-list>
  <ion-item
    *ngFor="let action of actions; let isLast = last"
    tapable="true"
    (click)="applyAction.emit(action)"
    [attr.lines]="isLast ? 'none' : 'full'"
  >
    <ion-icon [color]="action.color || 'dark'" [name]="action.icon"></ion-icon>
    <ion-label>{{ action.label }}</ion-label>
  </ion-item>
</ion-list>
